module.exports = __webpack_public_path__ + "img/btn_GDV_scoreBoard.38cfeb4b.svg";